import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, normalizeClass as _normalizeClass, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2443dc63"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "header"
};
const _hoisted_2 = {
  class: "title"
};
const _hoisted_3 = {
  class: "buttons"
};
const _hoisted_4 = {
  class: "body"
};
const _hoisted_5 = {
  class: "side"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "week"
}, null, -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "side-row"
}, "SP Strategy", -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "side-row sb-budget-label"
}, "SB Budget", -1));
const _hoisted_9 = {
  class: "side-row"
};
const _hoisted_10 = {
  class: "side-row"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "side-row"
}, "Budget saturation", -1));
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "side-row"
}, "Products activated", -1));
const _hoisted_13 = {
  class: "content"
};
const _hoisted_14 = ["onMouseenter"];
const _hoisted_15 = ["onMouseenter"];
const _hoisted_16 = ["onMouseenter"];
const _hoisted_17 = {
  key: 0,
  class: "strategy-info"
};
const _hoisted_18 = {
  key: 0
};
const _hoisted_19 = ["onMouseenter"];
const _hoisted_20 = ["onMouseenter"];
const _hoisted_21 = ["onMouseenter"];
const _hoisted_22 = ["id"];
const _hoisted_23 = ["onMouseenter"];
const _hoisted_24 = {
  class: "products"
};
const _hoisted_25 = {
  key: 0
};
const _hoisted_26 = {
  key: 1
};
const _hoisted_27 = ["onClick"];
const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_target_icon_v2 = _resolveComponent("target-icon-v2");
  const _component_stroked_plus_icon = _resolveComponent("stroked-plus-icon");
  const _component_app_button = _resolveComponent("app-button");
  const _component_app_icon = _resolveComponent("app-icon");
  const _component_currency_value = _resolveComponent("currency-value");
  const _component_percentage_value = _resolveComponent("percentage-value");
  const _component_WrapWithPopover = _resolveComponent("WrapWithPopover");
  const _component_FlexRow = _resolveComponent("FlexRow");
  const _component_ppc_strategy_shadow_row = _resolveComponent("ppc-strategy-shadow-row");
  const _component_ppc_graph = _resolveComponent("ppc-graph");
  const _component_app_popover = _resolveComponent("app-popover");
  const _component_app_card_custom = _resolveComponent("app-card-custom");
  const _component_ppc_strategies_modal = _resolveComponent("ppc-strategies-modal");
  const _component_omny_delete_modal = _resolveComponent("omny-delete-modal");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_app_card_custom, {
    "no-padding": ""
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createTextVNode(" Existing strategies "), _createElementVNode("div", {
      class: "go-to-current",
      onClick: _cache[0] || (_cache[0] = $event => $options.autoScrollToToday())
    }, [_createVNode(_component_target_icon_v2), _createTextVNode(" Go to current week ")])]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_app_button, {
      class: "create-strategy-button",
      variant: "outline-primary",
      v2: "",
      onClick: _cache[1] || (_cache[1] = $event => $options.onCreateOrEditStrategyForWeek(undefined, 'create'))
    }, {
      default: _withCtx(() => [_createVNode(_component_stroked_plus_icon, {
        color: "#312783",
        width: 20,
        height: 20
      }), _createTextVNode(" Create strategy ")]),
      _: 1
    })])]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_hoisted_6, _hoisted_7, _hoisted_8, _createElementVNode("div", _hoisted_9, [_createTextVNode(" Weekly budget available "), $props.currency ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 0
    }, [_createTextVNode("(in " + _toDisplayString($options.getCurrencySymbol($props.currency)) + ")", 1)], 64)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_10, [_createTextVNode(" Spend "), $props.currency ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 0
    }, [_createTextVNode("(in " + _toDisplayString($options.getCurrencySymbol($props.currency)) + ")", 1)], 64)) : _createCommentVNode("", true)]), _hoisted_11, _hoisted_12]), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", {
      class: "content-scroll",
      ref: "contentScroll",
      onWheel: _cache[3] || (_cache[3] = (...args) => $options.onWheel && $options.onWheel(...args)),
      onMouseleave: _cache[4] || (_cache[4] = (...args) => $options.onLeave && $options.onLeave(...args))
    }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.updatedWeeksStrategy, week => {
      return _openBlock(), _createElementBlock("div", {
        key: week.week,
        ref_for: true,
        ref: week.week_status == 'today' ? 'today' : week.week,
        class: _normalizeClass(['week-column', week.week_status, {
          relative: !week?.strategy
        }])
      }, [_createElementVNode("div", {
        class: _normalizeClass($options.rowClassName(week.week, 'week')),
        onMouseenter: $event => $options.onEnter(week.week, null, week.week_status)
      }, _toDisplayString(week.title), 43, _hoisted_14), _createElementVNode("div", {
        class: _normalizeClass([$options.rowClassName(week.week, 'strategy'), $options.showStrategyEditForWeek(week) ? `row-edit` : null, $options.isFutureStrategy(week) ? 'is-future' : null, $options.isFirstWeekInGroup(week) ? 'first' : null, $options.isLastWeekInGroup(week) ? 'last' : null]),
        onMouseenter: $event => $options.onEnter(week.week, 'strategy', week.week_status)
      }, [!!week?.strategy ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(['strategy-box', week.strategy_status])
      }, [_createElementVNode("div", {
        class: _normalizeClass(['strategy-inner', {
          hover: $data.hoverCampaignId == week.strategy_id
        }]),
        onMouseenter: $event => $options.onStrategyEnter(week),
        onMouseleave: _cache[2] || (_cache[2] = (...args) => $options.onStrategyLeave && $options.onStrategyLeave(...args))
      }, [!!week.strategy && (week.strategy_status == 'start' || week.strategy_status == 'single') ? (_openBlock(), _createElementBlock("div", _hoisted_17, [_createElementVNode("div", {
        class: _normalizeClass(['strategy-info-badge', week.strategy.type])
      }, [_createVNode(_component_app_icon, {
        icon: `strategy-${week.strategy.type}`
      }, null, 8, ["icon"]), week.strategy_status != 'single' ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(week.strategy.type.charAt(0).toUpperCase() + week.strategy.type.slice(1)), 1)) : _createCommentVNode("", true)], 2), _createElementVNode("div", {
        class: _normalizeClass(['strategy-info-value', {
          active: $data.hoverWeek != week || week.edit != 'single'
        }])
      }, [week.strategy.type === 'fixed' ? (_openBlock(), _createBlock(_component_currency_value, {
        key: 0,
        value: week.strategy.value,
        currency: $props.currency,
        allowPrecisionModification: false
      }, null, 8, ["value", "currency"])) : (_openBlock(), _createBlock(_component_percentage_value, {
        key: 1,
        value: week.strategy.value
      }, null, 8, ["value"]))], 2)])) : _createCommentVNode("", true), _withDirectives(_createVNode(_component_FlexRow, {
        gap: 8,
        class: _normalizeClass(['strategy-edit'])
      }, {
        default: _withCtx(() => [$options.isFutureStrategy(week) ? (_openBlock(), _createBlock(_component_WrapWithPopover, {
          key: 0,
          strategy: "fixed",
          onClick: $event => $options.onCreateOrEditStrategyForWeek(week, 'edit'),
          width: "fit-content"
        }, {
          title: _withCtx(() => [_createTextVNode("Edit")]),
          default: _withCtx(() => [_createVNode(_component_app_icon, {
            icon: "pencil"
          })]),
          _: 2
        }, 1032, ["onClick"])) : _createCommentVNode("", true), !$options.pastStrategyCondition(week) ? (_openBlock(), _createBlock(_component_WrapWithPopover, {
          key: 1,
          strategy: "fixed",
          onClick: $event => $options.onDeleteStrategy(week),
          width: "fit-content"
        }, {
          title: _withCtx(() => [_createTextVNode("Delete")]),
          default: _withCtx(() => [_createVNode(_component_app_icon, {
            icon: "delete",
            color: "#E7747A",
            size: 16
          })]),
          _: 2
        }, 1032, ["onClick"])) : _createCommentVNode("", true)]),
        _: 2
      }, 1536), [[_vShow, $options.isLastWeekInGroup(week)]])], 42, _hoisted_16)], 2)) : _createCommentVNode("", true)], 42, _hoisted_15), _createVNode(_component_ppc_strategy_shadow_row, {
        week: week,
        shadow: week.sb,
        rowName: "sb-budget",
        currency: $props.currency,
        rowClassName: $options.rowClassName,
        onEnter: $options.onEnter
      }, null, 8, ["week", "shadow", "currency", "rowClassName", "onEnter"]), _createElementVNode("div", {
        class: _normalizeClass($options.rowClassName(week.week, 'budget')),
        onMouseenter: $event => $options.onEnter(week.week, 'budget', week.week_status)
      }, [week?.budget.budget ? (_openBlock(), _createBlock(_component_ppc_graph, {
        key: 0,
        data: week?.budget.budget,
        max: $data.graph_max_budget,
        min: $data.graph_min_budget
      }, null, 8, ["data", "max", "min"])) : _createCommentVNode("", true)], 42, _hoisted_19), _createElementVNode("div", {
        class: _normalizeClass($options.rowClassName(week.week, 'spend')),
        onMouseenter: $event => $options.onEnter(week.week, 'spend', week.week_status)
      }, [week?.budget.budget ? (_openBlock(), _createBlock(_component_ppc_graph, {
        key: 0,
        showForecast: week?.week === $options.currentWeekString,
        data: week?.budget.spend,
        max: $data.graph_max_spend,
        min: $data.graph_min_spend,
        color: "#B885FF"
      }, null, 8, ["showForecast", "data", "max", "min"])) : _createCommentVNode("", true)], 42, _hoisted_20), _createElementVNode("div", {
        class: _normalizeClass($options.rowClassName(week.week, 'saturation')),
        onMouseenter: $event => $options.onEnter(week.week, 'saturation', week.week_status)
      }, [week?.budget_saturation ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createElementVNode("div", {
        class: _normalizeClass($options.saturationData(week.budget_saturation).className),
        id: `saturation${week.week}`
      }, null, 10, _hoisted_22), _createVNode(_component_app_popover, {
        target: `saturation${week.week}`,
        placement: "top"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString($options.saturationData(week.budget_saturation).tooltip), 1)]),
        _: 2
      }, 1032, ["target"])], 64)) : _createCommentVNode("", true)], 42, _hoisted_21), _createElementVNode("div", {
        class: _normalizeClass($options.rowClassName(week.week, 'products')),
        onMouseenter: $event => $options.onEnter(week.week, 'products', week.week_status)
      }, [week?.products_activated ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createElementVNode("div", _hoisted_24, _toDisplayString(week?.products_activated), 1), week?.products_activated_diff?.value != null ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(['products-diff', week.products_activated_diff.type])
      }, [week.products_activated_diff.value === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_25, " = ")) : (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(week.products_activated_diff.value), 1))], 2)) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true)], 42, _hoisted_23), $data.hoverWeek == week.week && (week.week_status == 'after' || week.week_status == 'today') && !week?.strategy ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "create-new",
        onClick: $event => $options.onCreateOrEditStrategyForWeek(week, 'create')
      }, [_createVNode(_component_app_icon, {
        icon: "plus"
      }), _createTextVNode(" Create"), _hoisted_28, _createTextVNode("strategy ")], 8, _hoisted_27)) : _createCommentVNode("", true)], 2);
    }), 128))], 544)])])]),
    _: 1
  }), $data.isModalVisible ? (_openBlock(), _createBlock(_component_ppc_strategies_modal, {
    key: 0,
    ref: "ppcStrategiesModal",
    modelValue: $data.isModalVisible,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.isModalVisible = $event),
    startWeekStrategy: _ctx.startWeekStrategy,
    onModalClose: $options.onModalClose,
    currency: $props.currency,
    isEdit: $options.isEditStrategy
  }, null, 8, ["modelValue", "startWeekStrategy", "onModalClose", "currency", "isEdit"])) : _createCommentVNode("", true), _createVNode(_component_omny_delete_modal, {
    modelValue: $data.deleteModalVisible,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $data.deleteModalVisible = $event),
    onDelete: $options.handleDeleteStrategy
  }, {
    title: _withCtx(() => [_createTextVNode("Delete Strategy")]),
    default: _withCtx(() => [_createTextVNode(" Are you sure you want to delete this strategy? ")]),
    _: 1
  }, 8, ["modelValue", "onDelete"])], 64);
}